// libs
import React from 'react';
import { css } from '@emotion/css';
import keyBy from 'lodash/keyBy';

import Platform from '@lyearn/core/utils/Platform';
import { Box } from '@lyearn/ui';
import useWindowSize from '@/hooks/useWindowSize';
import Grid from '@/modules/corporate/components/Grid';
import {
  OPTION_GRID_STYLES,
  OPTION_LIST_STYLES,
} from '@/modules/corporate/modules/questions/fields/single-select/styles';
import { getOptionListItemType } from '@/modules/corporate/modules/questions/fields/single-select/utils';

import { OptionsListProps } from './types';
const isNative = Platform.OS !== 'web';
const imageStyles = css`
  height: 27.8rem;
`;

function OptionsList(props: OptionsListProps) {
  const {
    options,
    onChange,
    renderQuestion,
    questionAttempt,
    ListItem,
    getKeyCode,
    correctAnswers,
    isWeightedOption,
  } = props;
  const { width } = useWindowSize();
  let selectedOptionsById = keyBy(questionAttempt?.submission?.optionResponse || [], 'optionId');
  const hasAttachment = options.find((option) => option.attachments?.length);
  const isQuestionSubmitted = Boolean(questionAttempt?.isSubmitted);
  const correctOptionsById = keyBy(correctAnswers?.correctOptions, 'optionId');

  const itemRenderer = React.useCallback(
    ({ index }: any) => {
      const option = options[index];

      return (
        <ListItem
          key={option.optionId}
          className="xs:mx-20 xs:my-2"
          index={index}
          isQuestionSubmitted={isQuestionSubmitted}
          keyCode={getKeyCode(option, index)}
          mediaContainerClassName={isNative ? imageStyles : undefined}
          option={option}
          type={getOptionListItemType({
            option,
            selectedOptionsById,
            isQuestionSubmitted,
            correctOptionsById,
            isWeightedOption,
            options,
          })}
          onChange={onChange}
        />
      );
    },
    [
      options,
      ListItem,
      isQuestionSubmitted,
      getKeyCode,
      selectedOptionsById,
      correctOptionsById,
      isWeightedOption,
      onChange,
    ],
  );

  const QuestionHeader = renderQuestion && renderQuestion();

  if (isNative) {
    return (
      <Grid
        ListHeaderComponent={QuestionHeader}
        itemRenderer={itemRenderer}
        itemSpacing={0}
        itemWidth={width}
        itemsCount={options.length}
      />
    );
  }

  return (
    <>
      {QuestionHeader}
      <Box className={hasAttachment ? OPTION_GRID_STYLES : OPTION_LIST_STYLES}>
        {options.map((_, index) => itemRenderer({ index }))}
      </Box>
    </>
  );
}

export default OptionsList;
